import { Grid } from "@material-ui/core";
import { Heading } from "../../headers/heading/heading.component";
import { DeleteButton } from "../../form-controls/button/delete-button/delete-button.component";
import { Divider } from "../../divider/divider.component";
import React from "react";
import { DrawerHeaderProps } from "./drawer-header.props";

export const DrawerHeader = (props: DrawerHeaderProps) => {
  return (
    <>
      <Grid container={true}>
        <Grid item={true} xs={6} sm={6} md={10} lg={10}>
          <Heading variant="primary">{props.header}</Heading>
        </Grid>
        <Grid item={true} xs={6} sm={6} md={2} lg={2}>
          <DeleteButton onClick={props.onClose} disabled={props.closeDisabled} size="medium" />
        </Grid>
      </Grid>
      <Divider />
    </>
  );
};
